<template>
  <form data-vv-scope="data-user">
    <div class="row mb-5">
      <div class="col-md-6 mt-3">
        <vs-input
          :readonly="onlyReadInfo"
          label="RUT"
          maxlength="10"
          v-model="userData.iut"
          class="w-full"
          name="rut"
          :danger="errors.has('data-user.rut')"
          :danger-text="errors.first('data-user.rut')"
          v-validate="'required|validateRut'"
        />
      </div>
      <div class="col-md-12 mt-3">
        <vs-input
          :readonly="onlyReadInfo"
          label="Nombre del usuario"
          maxlength="60"
          v-model="userData.nombre"
          class="w-full"
          name="name"
          :danger="errors.has('data-user.name')"
          :danger-text="errors.first('data-user.name')"
          v-validate="'required'"
        />
      </div>
      <div class="col-md-6 mt-3">
        <vs-input
          :readonly="onlyReadInfo"
          label="Alias"
          maxlength="60"
          v-model="userData.alias"
          class="w-full"
          name="alias"
          v-validate="'required'"
          :danger="errors.has('data-user.alias')"
          :danger-text="errors.first('data-user.alias')"
        />
      </div>
      <div class="col-md-6 mt-3">
        <vs-input
          :readonly="onlyReadInfo"
          label="Correo electrónico"
          maxlength="50"
          v-model="userData.correo"
          class="w-full"
          name="email"
          v-validate="'required|email'"
          :danger="errors.has('data-user.email')"
          :danger-text="errors.first('data-user.email')"
        />
      </div>
      <div class="col-md-12" v-if="product !== 'aduanas'">
        <div
          class="mt-5 mb-3"
          v-if="!onlyReadInfo"
        >
          <h5>
            Selecciona la(s) oficina(s) que se asignar&aacute;n al usuario:
          </h5>
        </div>
        <div class="row">
          <div class="col-md-6 mt-5">
            <div>
              <list-groups
                :disabled="onlyReadInfo"
                autocomplete
                label="Oficina numeración interna"
                v-model="userData.meta.oficina_int"
                name="internalOffice"
                :typeList="99"
                :officeType="'numInt'"
              />
            </div>
          </div>
          <div class="col-md-6 mt-5">
            <div>
              <list-groups
                :disabled="onlyReadInfo"
                autocomplete
                label="Oficina de Partes"
                v-model="userData.meta.oficina_ext"
                name="externalOffice"
                :typeList="98"
                :officeType="'numOf'"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-3" v-if="product !== 'aduanas' && onlyReadInfo">
        <vs-input
          readonly
          label="Firma Simple"
          maxlength="60"
          v-model="userData.firmaSimple"
          class="w-full"
          name="simpleSign"
        />
      </div>
      <div class="col-md-6 mt-3" v-if="product !== 'aduanas' && onlyReadInfo">
        <vs-input
          readonly
          label="Firma Avanzada"
          maxlength="60"
          v-model="userData.firmaAvanzada"
          class="w-full"
          name="advancedSign"
        />
      </div>
      <div class="col-md-12 mt-5 mb-3" v-if="product !== 'aduanas' && onlyReadInfo">
        <groups-list
          :title="'Oficinas Internas'"
          :groups="userInternalOffice"
          :loading="loadingCompanyUserGroups"
        />
      </div>
      <div class="col-md-12 mt-5 mb-3" v-if="product !== 'aduanas' && onlyReadInfo">
        <groups-list
          :title="'Oficinas Externas'"
          :groups="userExternalOffice"
          :loading="loadingCompanyUserGroups"
        />
      </div>
      <div class="col-md-12 mt-5 mb-3" v-if="product !== 'aduanas' && onlyReadInfo">
        <groups-list
          :title="'Grupos de Usuario'"
          :groups="userGroups"
          :loading="loadingCompanyUserGroups"
        />
      </div>
      <div class="col-md-12 mt-3">
        <div style="float: right">
          <vs-button
            class="action"
            color="primary"
            @click="saveChanges()"
            icon="save"
            :disabled="loading"
            v-if="!onlyReadInfo"
          >
            Guardar
            <b-spinner
              v-if="loading"
              small
              variant="ligth"
            />
          </vs-button>
        </div>
      </div>
    </div>
    <div
      class="row"
      v-if="action === 'add' && group && !group.isRoot"
    >
      <div class="col-12">
        <b>Este usuario pertenecer&aacute; al grupo: </b> <span class="badge badge-success">
          {{ group.nombre }}
        </span>
      </div>
    </div>
  </form>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import ListGroups from '@/febos/chile/lists/components/ListGroups';
import GroupsList from '@/febos/global/management/vistas/components/GroupsList';
import RutMixin from '@/febos/chile/_vue/mixins/RutMixin';
import { ioCompanyGroups, signsUser } from '@/febos/servicios/api/empresas.api';

export default {
  name: 'ManageUser',
  components: {
    ListGroups,
    GroupsList
  },
  mixins: [RutMixin],
  props: {
    user: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    group: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      product: process.env.VUE_APP_PRODUCTO,
      userData: {
        ...this.user,
        meta: {
          oficina_int: '',
          oficina_ext: ''
        }
      },
      delete: '*ELIMINAR*',
      loading: false,
      loadingCompanyUserGroups: false,
      loadingUserSign: true,
      forGroup: false,
      userCompanyGroups: [],
    };
  },
  async created() {
    // this.rutValidation();
    if (this.action !== 'add') {
      await this.getWorkerData({
        tipoRespuesta: 2, // Hay 1 y 2
        elementoId: this.user.id,
        referenciaId: this.company.id,
        filtros: 'nombre:OFICINA_INT,OFICINA_EXT'
      });
      this.userData.meta.oficina_int = this.workerData.oficina_int?.valor;
      this.userData.meta.oficina_ext = this.workerData.oficina_ext?.valor;
    }
  },
  mounted() {
    if (this.onlyReadInfo) {
      this.fetchUserCompanyGroups();
      this.getUserSign();
    }
  },
  watch: {
    user(newValue) {
      this.userData = { ...newValue };
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersByGroup'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Management', [
      'workerData'
    ]),
    userInternalOffice() {
      return this.userCompanyGroups.filter((group) => group.esOficina === 'Y' && group.tipo === 'int');
    },
    userExternalOffice() {
      return this.userCompanyGroups.filter((group) => group.esOficina === 'Y' && group.tipo === 'ext');
    },
    userGroups() {
      return this.userCompanyGroups.filter((group) => group.esOficina === 'N');
    },
    onlyReadInfo() {
      return this.action === 'visualize';
    },
    showModal: {
      get() {
        return this.modalName === 'modalUser';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Usuario', [
      'updateUserComppany',
      'createUserCompany'
    ]),
    ...mapActions('Management', [
      'getWorkerData'
    ]),
    ...mapActions('Empresas', [
      'addUserToGroupV2',
      'getUserSigns'
    ]),
    rutValidation() {
      /* Crea un validacion perzonalizada con VeeValidate v2
      La funcion this.validateRUT se toma del RutMixin */
      this.$validator.extend('validateRut', {
        getMessage: () => 'El rut es incorrecto',
        validate: (value) => {
          const valid = this.validateRUT(value);
          return valid;
        }
      });
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addUser(user) {
      await this.addUserToGroupV2({
        companyId: this.company.id,
        groupId: this.group.id,
        userId: user.id
      });
    },
    async saveChanges() {
      const isValid = await this.validateForm('data-user');
      if (!isValid) {
        return;
      }
      const user = {
        iut: this.userData.iut,
        alias: this.userData.alias,
        correo: this.userData.correo,
        nombre: this.userData.nombre,
        tipo: 1, // nacional
        nivel: 1,
        cambiarClave: 'si',
        accesoWeb: 'si'
      };
      user.meta = {
        oficina_int: this.userData.meta.oficina_int || this.delete,
        oficina_ext: this.userData.meta.oficina_ext || this.delete
      };

      if (this.action === 'edit') {
        user.id = this.userData.id;
      }

      if (this.action === 'add') {
        try {
          this.loading = true;
          if (!this.group?.isRoot) this.forGroup = true;
          const resp = await this.createUserCompany({ user, forGroup: this.forGroup });
          if (this.group && !this.group?.isRoot) {
            // Agrega el usuario creado al grupo en cuestion
            await this.addUser(resp);
          }
        } finally {
          this.loading = false;
        }
      } else {
        try {
          this.loading = true;
          await this.updateUserComppany(user);
        } finally {
          this.loading = false;
        }
      }
      this.$emit('close-manage-user', true);
    },
    closeManageUser() {
      this.$emit('close-manage-user', true);
    },
    async fetchUserCompanyGroups() {
      this.userCompanyGroups = [];
      this.loadingCompanyUserGroups = true;
      const response = await ioCompanyGroups(
        {
          empresaId: this.company.id,
          filtros: `usuarioId:${this.userData.id}`
        }
      );
      this.userCompanyGroups = response.data.grupos;
      this.loadingCompanyUserGroups = false;
    },
    async getUserSign() {
      const response = await signsUser(this.userData.iut);
      this.userData = {
        ...this.userData,
        firmaSimple: response.data.puedeFirmarSimple ? 'Si' : 'No',
        firmaAvanzada: response.data.puedeFirmarAvanzada ? 'Si' : 'No',
      };
    },
  }
};

</script>
<style scoped>
.badge {
  font-size: 15px;
  padding: 6px;
}

.chip-custom {
  font-size: 12px;
  margin-top: 10px;
  color: #ffb300;
  background: #fff5df;
  border-radius: 10px;
  padding: 4px 8px;
}
</style>
